/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'team-central.give-jira-kudos.created.description.flag': '今後は Workplace Experience チームがギフト リクエストを適切に処理します。✨',
  'team-central.give-jira-kudos.created.title.flag': '賞賛が作成されました',
  'team-central.give-jira-kudos.creation.failed.description.flag': '賞賛の作成とギフトの送付ができませんでした。<a>go/kudos</a> で別のチケットを登録してください。',
  'team-central.give-jira-kudos.creation.failed.title.flag': '問題が発生しました',
  'team-central.give-kudos.button': '賞賛を送る',
  'team-central.give-kudos.close-button.label': 'ドロワーを閉じる',
  'team-central.give-kudos.confirm-close.title': '確認して閉じる',
  'team-central.give-kudos.created.description.flag': '賞賛を送りました。作成した<a>賞賛の一覧をご覧ください</a>。',
  'team-central.give-kudos.created.title.flag': '賞賛が作成されました',
  'team-central.give-kudos.creation.failed.description.flag': '賞賛を作成できませんでした。',
  'team-central.give-kudos.creation.failed.title.flag': '問題が発生しました',
  'team-central.give-kudos.error-icon.label': 'エラー',
  'team-central.give-kudos.success-icon.label': '成功',
  'team-central.give-kudos.unsaved.warning': 'あなたが行った変更は保存されません。',
  'team-central.give-kudos.unsaved.warning.cancel': 'キャンセル',
  'team-central.give-kudos.unsaved.warning.close': '閉じる'
};